import _ from 'lodash';

import environment from '../../../environment';
import { NOTIFY_TYPE, notifyError } from '../../../shared/notify';
import fetch from '../../fetch';
import reducers from './reducers';
import translate from '../../../core/tools/translate';
import { fetchBlob } from '../../fetchBlob';
import moment from 'moment';

const afterSales = (() => {
    const _success = function (res) {
        if (!_.size(res) || !_.some(res, r => r.value !== 0)) {
            const message = {
                type: NOTIFY_TYPE.LOG,
                text: 'Não existem dados para o filtro selecionado'
            };
            notifyError(null, message);
        }

        const output = {
            consolidate: {},
            consolidatePGT: {}
        };

        if (_.some(res, r => String(r.name).trim() === 'Social Class')) {
            _.forEach(res, loc => {
                output.consolidate[loc.localeId] = loc.value;
            });

            return output;
        }

        const mapData = (f, key) => ({
            localeId: key,
            value: _.sumBy(f, 'value'),
            valuePGT: _.sumBy(f, 'valuePGT'),
            values: f
        });

        const groupByLocale = _(res)
            .groupBy(f => f.localeId)
            .map(mapData)
            .value();

        _.forEach(groupByLocale, value => {
            let val = value.value;
            let valPGT = value.valuePGT;

            if (isNaN(val)) val = 0;
            if (isNaN(valPGT)) valPGT = 0;

            const calcVal = Number((val * 100)).toFixed(2) / 100;
            const calcValPGT = Number((valPGT * 100)).toFixed(2) / 100;

            value.values.value = calcVal;
            value.values.valuePGT = calcValPGT;

            output.consolidate[value.localeId] = calcVal;
            output.consolidatePGT[value.localeId] = calcValPGT;
        });

        return output;
    };

    const get = {
        themes: {},
        summary: {},
        protectArea: {},
        serviceArea: {},
        getSalesByStoreId: {},
        stores: {},
        multicriteria: {},
        customers: {},
    };

    const request = (
        url,
        { then = res => res, mapUrl = null, hasHeader = true, method = 'POST' } = { then: res => res, method: 'POST' }
    ) => req =>
            fetch({
                type: method,
                url: `${environment.get('API_HOST')}/${!!mapUrl ? mapUrl(req) : url}`,
                header: hasHeader && {
                    'X-UIKey': 'dynamic-maps-layers'
                },
                data: method === 'POST' ? JSON.stringify(req) : req,
                error: notifyError
            }).then(res => then(res, req));

    const requestThemeData = request('aftersales/locales/data', { then: _success });

    get.themes = requestThemeData;

    get.getSalesByStoreId = storeId => {
        const _error = err => {
            console.log(`ERROR: ${err}`);
            return null;
        };

        return fetch({
            type: 'GET',
            url: `${environment.get('API_HOST')}/aftersales/stores/${storeId}/sales`,
        }).then((resp) => resp, _error);
    };

    get.summary.vehicleRepairableYear = (localeIds, yearInitial, yearEnd, typeSearch) => {
        const locales = localeIds.reduce((acc, localeId) => `${acc}&localeIds=${localeId}`, '');
        return fetch({
            type: 'GET',
            url: `${environment.get('API_HOST')}/aftersales/summaries/vehiclefleetdata/year?${locales}&yearInitial=${yearInitial}&yearEnd=${yearEnd}&typeSearch=${typeSearch}`,
        }).then(reducers.vehicleRepairableYear);
    };

    get.summary.vehicleRepairableBrand = (localeIds, yearInitial, yearEnd) => {
        const locales = localeIds.reduce((acc, localeId) => `${acc}&localeIds=${localeId}`, '');
        return fetch({
            type: 'GET',
            url: `${environment.get('API_HOST')}/aftersales/summaries/vehiclefleetdata/brands?${locales}&yearInitial=${yearInitial}&yearEnd=${yearEnd}`,
        }).then(reducers.vehicleRepairableBrand);
    };

    get.summary.vehicleRepairableBrandEvoluation = (localeIds, yearInitial, yearEnd) => {
        const locales = localeIds.reduce((acc, localeId) => `${acc}&localeIds=${localeId}`, '');
        return fetch({
            type: 'GET',
            url: `${environment.get('API_HOST')}/aftersales/summaries/vehiclefleetdata/brands/evoluation?${locales}&yearInitial=${yearInitial}&yearEnd=${yearEnd}`,
        }).then(e => reducers.vehicleRepairableDataEvoluation(e, 'brandName', translate('Common.Brand')));
    };

    get.summary.vehicleRepairableSegment = (localeIds, yearInitial, yearEnd, segments) => {
        const localesQuery = localeIds.reduce((acc, localeId) => `${acc}&localeIds=${localeId}`, '');
        const segmentsQuery = segments.reduce((acc, segment) => `${acc}&segmentIds=${segment}`, '');
        return fetch({
            type: 'GET',
            url: `${environment.get('API_HOST')}/aftersales/summaries/vehiclefleetdata/segments?${segmentsQuery}&${localesQuery}&yearInitial=${yearInitial}&yearEnd=${yearEnd}`,
        }).then(reducers.vehicleRepairableSegment);
    };

    get.summary.vehicleRepairableSegmentExtend = (localeIds, yearInitial, yearEnd) => {
        const locales = localeIds.reduce((acc, localeId) => `${acc}&localeIds=${localeId}`, '');
        return fetch({
            type: 'GET',
            url: `${environment.get('API_HOST')}/aftersales/summaries/vehiclefleetdata/segments/extend?${locales}&yearInitial=${yearInitial}&yearEnd=${yearEnd}`,
        }).then(e => reducers.vehicleRepairableDataEvoluation(e, 'segmentName', translate('Common.Segment')));
    };

    get.summary.storesRanking = (localeIds) => {
        const locales = localeIds.reduce((acc, localeId) => `${acc}&localeIds=${localeId}`, '');
        return fetch({
            type: 'GET',
            url: `${environment.get('API_HOST')}/aftersales/summaries/storesranking?${locales}`,
        }).then(reducers.storesRanking);
    };

    get.summary.brandsRanking = (localeIds) => {
        const locales = localeIds.reduce((acc, localeId) => `${acc}&localeIds=${localeId}`, '');
        return fetch({
            type: 'GET',
            url: `${environment.get('API_HOST')}/aftersales/summaries/brandsranking?${locales}`,
        }).then(reducers.brandsRanking);
    };

    get.summary.exportExcel = (localeIds, locationName, yearInitial, yearEnd) => {
        const locales = localeIds.reduce((acc, localeId) => `${acc}&localeIds=${localeId}`, '');
        const fileName = `Neocom_Sumario ${locationName}_v${moment().format('YYYYMMDD')}`;
        return fetchBlob({
            fileName: `${fileName}.xlsx`,
            url: `${environment.get('API_HOST')}/aftersales/summaries/export/excel?${locales}&yearInitial=${yearInitial}&yearEnd=${yearEnd}`,
            type: 'GET',
        });
    };

    get.protectArea = async (isDealer, storeType, storeId, bbox) => {
        const storeQuery = storeId
            ? `&storeId=${storeId}`
            : '';
        const storeTypeQuery = storeType
            ? `&storeType=${storeType}`
            : '';

        const bboxData = typeof (bbox) === 'undefined' || bbox === 'null' ? '' : bbox;

        return fetch({
            type: 'GET',
            url: `${environment.get('API_HOST')}/aftersales/stores/protectareas?isDealer=${isDealer}${storeQuery}${storeTypeQuery}&bbox=${bboxData}`,
            noLoading: true
        }).then(reducers.protectArea);
    };

    get.serviceArea = async (storeId, serviceType, bbox) => {
        const bboxData = typeof (bbox) === 'undefined' || bbox === 'null' ? '' : bbox;
        const storeQuery = storeId ? `&storeId=${storeId}` : '';
        return fetch({
            type: 'GET',
            url: `${environment.get('API_HOST')}/aftersales/stores/serviceareas?serviceType=${serviceType}${storeQuery}&bbox=${bboxData}`,
            noLoading: true
        }).then(reducers.serviceArea);
    };

    get.serviceArea.indicators = async (storeId, serviceType) => {
        return fetch({
            type: 'GET',
            url: `${environment.get('API_HOST')}/aftersales/stores/serviceareaindicators?storeId=${storeId}&serviceType=${serviceType}`
        }).then(e => reducers.serviceAreaIndicatorsCalculated(e));
    };

    get.stores.allNetwork = () => {
        return fetch({
            type: 'GET',
            url: `${environment.get('API_HOST')}/aftersales/stores?type=1`,
        });
    };

    get.stores.allCompetitors = () => {
        return fetch({
            type: 'GET',
            url: `${environment.get('API_HOST')}/aftersales/stores?type=2`,
        });
    };

    get.stores.export = ({ storesIds, type, bbox, filename }) => {
        return fetchBlob({
            fileName: filename,
            url: `${environment.get('API_HOST')}/aftersales/stores/export`,
            type: 'POST',
            parameters: {
                StoresIds: storesIds,
                Type: type,
                Bbox: bbox,
            },
        });
    };

    get.multicriteria.getCalculateds = (multicriteriaId, type) => {
        return fetch({
            type: 'GET',
            url: type
                ? `${environment.get('API_HOST')}/aftersales/multicriterias/${multicriteriaId}/calculateds/${type}`
                : `${environment.get('API_HOST')}/aftersales/multicriterias/${multicriteriaId}/calculateds/0`,
        }).then(reducers.multicriteriaCalculateds);
    };

    get.multicriteria.exportXls = (multicriteriaIds, type, filename, bbox) => {
        return fetchBlob({
            fileName: filename,
            url: `${environment.get('API_HOST')}/aftersales/multicriterias/export`,
            type: 'POST',
            parameters: {
                multicriteriaIds,
                bbox,
                type
            },
        });
    };

    get.customers.exportSummaryCustom = (parameters) => {
        return fetchBlob({
            url: `${environment.get('API_HOST')}/aftersales/customers/export`,
            type: 'POST',
            parameters: parameters
        });
    };

    return {
        get
    };
})();

export default afterSales;



// WEBPACK FOOTER //
// ./src/scripts/api/endpoints/afterSales/index.js